<template>
    <div v-if="spinner" class="spinner-overlay">
        <div class="spinner-grow text-light ms-1" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoadingOverlay",
    props: ["loading"],
    data() {
        return {
            spinner: false,
            bodyClass: document.querySelector("body").classList,
        };
    },
    watch: {
        loading: {
            handler() {
                this.stopScroll();
            },
            deep: true,
        },
    },
    methods: {
        showSpinner() {
            this.spinner = true;
        },
        hideSpinner() {
            this.spinner = false;
        },
        stopScroll() {
            if (this.loading) this.bodyClass.add("stop-scroll");
            else this.bodyClass.remove("stop-scroll");
        },
    },
    updated() {
        if (this.loading) this.showSpinner();
        else this.hideSpinner();
    },
};
</script>

<style scoped>
.spinner-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: var(--c-dark);
    top: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    z-index: 9999;
}
</style>
